import { RsValue } from '../../../models/base/BaseModel';
import {
  IExpenseParam,
  IExpenseResult,
  IExpenseUpdateParam,
} from '../../../models/expense/ExpenseModel';
import api from '../../axios';

export const expenseService = {
  listExpenses: (
    params?: any
  ): Promise<{ rows: IExpenseResult[]; lastRow: number; count: number }> =>
    api.get('/odata/Expense', params),

  createExpense: (formData: FormData): Promise<RsValue<IExpenseResult>> =>
    api.post('/Expense', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),

  updateExpense: (id: number, formData: FormData): Promise<RsValue<IExpenseResult>> =>
    api.put(`/Expense/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),

  deleteExpense: (id: number): Promise<RsValue<boolean>> => api.delete(`/Expense/${id}`),

  getExpenseById: (id: number): Promise<RsValue<IExpenseResult>> => api.get(`/Expense/${id}`),

  downloadExpenseFile: async (fileUniqueId: string): Promise<void> => {
    const response = await api.get(`/Expense/files/${fileUniqueId}/download`, {
      responseType: 'blob' as const,
    });

    const disposition = (response.headers?.['content-disposition'] as string) || '';
    const contentType = ((response.headers?.['content-type'] as string) || '').toLowerCase();
    const match = disposition.match(/filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i);
    let filename = match?.[1] || match?.[2] || '';
    try {
      if (filename) filename = decodeURIComponent(filename);
    } catch (_) {}

    if (!filename) {
      let extension = '';
      if (contentType.includes('pdf')) extension = '.pdf';
      else if (contentType.includes('png')) extension = '.png';
      else if (contentType.includes('jpeg') || contentType.includes('jpg')) extension = '.jpg';
      else if (contentType.includes('gif')) extension = '.gif';
      else if (contentType.includes('zip')) extension = '.zip';
      filename = `expense_file_${fileUniqueId}${extension}`;
    }

    const blob = response.data as Blob;
    const downloadUrl = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = downloadUrl;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.URL.revokeObjectURL(downloadUrl);
  },
};
